import React from 'react'

export const AESSInfo = (data:any) => {
    const {lead_symptoms,lead_budget_range,lead_gender,lead_age_range,lead_language,lead_severity} = data;
  return (
    <div className="col-sm-12 mt-5">
        <table className="table table-striped border-0 mt-4">
        <tbody>
          <tr>
            <th scope="row">Lead Symptoms:</th>
            <td colSpan={3}>{lead_symptoms ? lead_symptoms.join(", ") : ""}</td>
          </tr>
          <tr>
            <th scope="row">Lead Budget Range:</th>
            <td>{lead_budget_range}</td>
          </tr>
          <tr>
            <th scope="row">Lead Gender:</th>
            <td colSpan={3}>{lead_gender ? lead_gender.join(", "): ""}</td>
          </tr>
          <tr>
            <th scope="row">Lead Age Range:</th>
            <td colSpan={3}>{lead_age_range}</td>
          </tr>
          <tr>
            <th scope="row">Lead Language:</th>
            <td colSpan={3}>{lead_language ? lead_language.join(", ") : ""}</td>
          </tr>
          <tr>
            <th scope="row">Lead Severity:</th>
            <td colSpan={3}>{lead_severity ? lead_severity.join(", "): ""}</td>
          </tr>
        </tbody>
      </table>
        </div>
  )
}
